import { render, staticRenderFns } from "./ExportHistory.vue?vue&type=template&id=3faa374a&scoped=true"
import script from "./ExportHistory.vue?vue&type=script&lang=js"
export * from "./ExportHistory.vue?vue&type=script&lang=js"
import style0 from "./ExportHistory.vue?vue&type=style&index=0&id=3faa374a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faa374a",
  null
  
)

export default component.exports